export const calculateAge = (birthDateString: string | null | undefined): number | '' => {
  if (!birthDateString) {
    return '';
  }
  const birthDate = new Date(birthDateString);
  if (isNaN(birthDate.getTime())) {
    return '';
  }
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  const dayDiff = today.getDate() - birthDate.getDate();
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age < 0 ? 0 : age;
};

interface IntelligenceResult {
  intelligence: string;
  score: number;
}

export function calculateIntelligenceGrade(result: IntelligenceResult[]): Record<string, string> {
  if (!result || result.length === 0) {
    return {};
  }
  // 4개 미만 지능 포착 시 등급 없음
  if (result.length < 4) {
    return {};
  }
  // score 기준으로 내림차순 정렬
  const sorted = [...result].sort((a, b) => b.score - a.score);
  const gradeMap: Record<string, string> = {};
  if (result.length === 8) {
    // 8개 지능 모두 포착 시
    // 우수: 상위 2개
    sorted.slice(0, 2).forEach((item) => {
      gradeMap[item.intelligence] = 'report.summary.excellent';
    });
    // 보완: 하위 2개
    sorted.slice(-2).forEach((item) => {
      gradeMap[item.intelligence] = 'report.summary.needs_improvement';
    });
    // 일반: 중위 4개
    sorted.slice(2, -2).forEach((item) => {
      gradeMap[item.intelligence] = 'common.general';
    });
  } else if (result.length >= 4 && result.length < 8) {
    // 8개 미만 4개 이상 지능 포착 시
    // 우수: 상위 2개
    sorted.slice(0, 2).forEach((item) => {
      gradeMap[item.intelligence] = 'report.summary.excellent';
    });
    // 보완: 하위 2개
    sorted.slice(-2).forEach((item) => {
      gradeMap[item.intelligence] = 'report.summary.needs_improvement';
    });
    // 일반: 남은 개수
    sorted.slice(2, -2).forEach((item) => {
      gradeMap[item.intelligence] = 'common.general';
    });
  }
  return gradeMap;
}
